import {
  IGridTableHeaderModel,
} from '@types-custom/models/ui/grid-table-model';

export enum AuditTypeEnum {
  Users = 'USER',
  Cameras = 'CAMERA',
  Sensor = 'SENSOR',
  Incident = 'INCIDENT'
}
export const gridAuditHeadersMap = ():
{ [key: string]: IGridTableHeaderModel[] } => ({
  [AuditTypeEnum.Users]: [
    { key: 'documentType', label: 'Tipo de documento' },
    { key: 'identification', label: 'Número de documento' },
    { key: 'firstName', label: 'Nombres' },
    { key: 'lastName', label: 'Apellidos' },
    { key: 'email', label: 'Correo Electrónico' },
    { key: 'username', label: 'Usuario' },
    { key: 'phone', label: 'Número telefónico' },
  ],
  [AuditTypeEnum.Cameras]: [
    { key: 'address', label: 'Dirección' },
    { key: 'description', label: 'Descripción' },
    { key: 'ip', label: 'IP' },
    { key: 'manufacturer', label: 'Fabricante' },
    { key: 'model', label: 'Modelo' },
    { key: 'name', label: 'Nombre' },
    { key: 'protocol', label: 'Protocolo' },
    { key: 'serial', label: 'Serial' },
    { key: 'url', label: 'URL' },
    { key: 'userNameLogin', label: 'Usuario' },
    { key: 'versionFw', label: 'Versión' },
    { key: 'cameraType', label: 'Tipo cámara' },
    { key: 'status', label: 'Estado' },
    { key: 'postalCode', label: 'Código postal' },
  ],
  [AuditTypeEnum.Sensor]: [
    { key: 'address', label: 'Dirección' },
    { key: 'description', label: 'Descripción' },
    { key: 'gateway', label: 'Gateway' },
    { key: 'mac', label: 'MAC' },
    { key: 'manufacturer', label: 'Fabricante' },
    { key: 'model', label: 'Modelo' },
    { key: 'name', label: 'Nombre' },
    { key: 'protocol', label: 'Protocolo' },
    { key: 'serial', label: 'Serial' },
    { key: 'url', label: 'URL' },
    { key: 'userNameLogin', label: 'Usuario' },
    { key: 'versionFw', label: 'Versión' },
    { key: 'sensorType', label: 'Tipo sensor' },
    { key: 'status', label: 'Estado' },
  ],
  [AuditTypeEnum.Incident]: [
    { key: 'beginDate', label: 'Fecha inicio' },
    { key: 'endDate', label: 'Fecha fin' },
    { key: 'situation', label: 'Sitiación' },
    { key: 'state', label: 'Estado' },    
    { key: 'location', label: 'Ubicación' },
    { key: 'category', label: 'Categoría' },
    { key: 'subcategory', label: 'Subcategoría' },
    { key: 'involvedAmount', label: 'Vehículos involucrados' },
    { key: 'postalCode', label: 'Código postal' },
    { key: 'source', label: 'Fuente' },
    { key: 'media', label: 'Medio' },
    { key: 'severity', label: 'Severidad' },
    { key: 'priority', label: 'Prioridad' },
  ],
});
